export const spinnerExamples = {
  1: `// Ring spinner

const options = {
  type: 1,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  2: `// Dual color spinner

const options = {
  type: 2,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  3: `// Dots spinner

const options = {
  type: 3,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  4: `// Pulse spinner

const options = {
  type: 4,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  5: `// Bars spinner

const options = {
  type: 5,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  6: `// Grid spinner

const options = {
  type: 6,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  7: `// Double ring spinner

const options = {
  type: 7,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  8: `// Circle dots spinner

const options = {
  type: 8,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  9: `// Flip spinner

const options = {
  type: 9,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  10: `// Gooey spinner

const options = {
  type: 10,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  11: `// Corner spinner

const options = {
  type: 11,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  12: `// Ripple effect

const options = {
  type: 12,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  13: `// Pendulum spinner

const options = {
  type: 13,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  14: `// Snake spinner

const options = {
  type: 14,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  15: `// Bounce dots spinner

const options = {
  type: 15,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  16: `// Spiral spinner

const options = {
  type: 16,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  17: `// Clock spinner

const options = {
  type: 17,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  18: `// Gradient spinner

const options = {
  type: 18,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  19: `// Zigzag spinner

const options = {
  type: 19,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  20: `// Orbit spinner

const options = {
  type: 20,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  21: `// Square spin spinner

const options = {
  type: 21,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  22: `// Slice spinner

const options = {
  type: 22,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  23: `// Ping spinner

const options = {
  type: 23,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  24: `// Infinity spinner

const options = {
  type: 24,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  25: `// Windmill spinner

const options = {
  type: 25,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  26: `// Hexagon spinner

const options = {
  type: 26,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  27: `// Triangle spin spinner

const options = {
  type: 27,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  28: `// Diamond spinner

const options = {
  type: 28,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  29: `// Star spinner

const options = {
  type: 29,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  30: `// Gear spinner

const options = {
  type: 30,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  31: `// Dots wave spinner

const options = {
  type: 31,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  32: `// Worm spinner

const options = {
  type: 32,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  33: `// Squares rotate spinner

const options = {
  type: 33,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  34: `// Helix spinner

const options = {
  type: 34,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  35: `// Circles merge spinner

const options = {
  type: 35,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  36: `// Atom spinner

const options = {
  type: 36,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  37: `// Roller spinner

const options = {
  type: 37,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  38: `// Cascade spinner

const options = {
  type: 38,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  39: `// Blockchain spinner

const options = {
  type: 39,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  40: `// Heartbeat spinner

const options = {
  type: 40,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  41: `// Flower spinner

const options = {
  type: 41,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  42: `// Radar spinner

const options = {
  type: 42,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  43: `// Wave circle spinner

const options = {
  type: 43,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  44: `// Pacman spinner

const options = {
  type: 44,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  45: `// Hourglass spinner

const options = {
  type: 45,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  46: `// Cube fold spinner

const options = {
  type: 46,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  47: `// Dashed ring spinner

const options = {
  type: 47,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  48: `// Newton cradle spinner

const options = {
  type: 48,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  49: `// Metronome spinner

const options = {
  type: 49,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`,

  50: `// Spinner box

const options = {
  type: 50,
  size: 3,              // rem
  color: "#61dafb",
  secondaryColor: "#fff",
  backgroundColor: "#282c34",
  speed: 1,              // seconds
  borderWidth: 4         // px
};

<Spinner {...options} />`
};
